<template>
  <div class="all">
    <h2 class="large-title">Pertamina Report</h2>
    <div class="all__filter">
      <adx-selectdropdown :label="`Pilih SPBU`" :value.sync="spbu" :options="spbuOptions" />
      <div :class="['dropdown']">
        <label class="small-font">Tanggal Awal</label>
        <v-date-picker
          v-model='startDate'
          :max-date='new Date()'
          :popoverVisibility="'focus'"
          :theme-styles='themeStyles'
          class='date-input'>
          <input
            class="calendar-start"
            placeholder= "DD/MM/YYYY"
            type='text'
            slot-scope='{ inputValue, updateValue }'
            :value='inputValue'
            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
        </v-date-picker>
      </div>
      <div :class="['dropdown']">
        <label class="small-font">Tanggal Akhir</label>
        <v-date-picker
          v-model='endDate'
          :max-date='new Date()'
          :popoverVisibility="'focus'"
          :theme-styles='themeStyles'
          class='date-input'>
          <input
            class="calendar-start"
            placeholder= "DD/MM/YYYY"
            type='text'
            slot-scope='{ inputValue, updateValue }'
            :value='inputValue'
            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
        </v-date-picker>
      </div>
    </div>
      <button class="btn-large secondary" @click="download">Download</button>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Secondary'
import calendar from 'v-calendar'
import moment from 'moment';
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-user_list',
  components: {
    'v-calendar': calendar,
    'adx-selectdropdown': SelectDropdown,
  },
  props: {

  },
  data() {
    return {
      spbu: null,
      startDate: null,
      endDate: null,
      spbuOptions: [
        {
          label: 'Semua SPBU',
          value: 0
        }
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      statusList: [
        {
          "id": 1,
          "value": "",
          "label": "All New Users"
        },
        {
          "id": 2,
          "value": "wnc",
          "label": "With No Campaign"
        },
      ],
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    let date = new Date()
    this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
    this.endDate = date
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        const response = await api.get(apiV2.pertaminaLocations, { needToken: true })
        if (response.status == 200 ) {
          const { data } = response
          if (data.length) {
            data[0].locations.map(obj => {
              this.spbuOptions.push({
                "label": obj.title,
                "value": obj.id
              })
            })
          } else {
            this.locationEmpty = true
          }
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    inputValidation(input) {
      let data = { isValid: true, errorMessage: null }

      if(input == null) {
        data.isValid = false
        data.errorMessage = "Pilihan SPBU tidak boleh kosong"
      }

      return data
    },
    download() {
      let validation = this.inputValidation(this.spbu)
      if (validation.isValid) {
        let endDate = moment(this.endDate).format('YYYY-MM-DD')
        let startDate = this.startDate
        
        if (startDate) {
          startDate = moment(startDate).format('YYYY-MM-DD')
        } else {
          startDate = ''
        }
        window.location = apiV2.pertaminaReport(this.spbu, startDate, endDate)
      } else {
        this.raiseError(validation.errorMessage)
      }
    },
    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>